/* tslint:disable */

export interface Query {
  networksCount: number;
  networks: Network[];
  portsCount: number;
  traffic: TimestampTraffic[];
  traffics: TimestampTraffic[];
  trafficPeak: number;
  twitterFeed: Tweet[];
}

export interface Network {
  name: string;
  asNumber: string;
  peeringPolicy: PeeringPolicy;
  routeServers: boolean;
}

export interface TimestampTraffic {
  timestamp: number;
  traffic: number;
}

export interface Tweet {
  author: string;
  postedAt: number;
  body: string;
}

export interface Mutation {
  contactSales: ContactUsResult;
  contactSupport: ContactUsResult;
}

export interface ContactUsResult {
  successful: boolean;
  validationErrors?: ValidationError[] | null;
}

export interface ValidationError {
  message: ErrorMessage;
  path: string[];
}

export interface TimestampRangeInput {
  since: number;
  until: number;
}

export interface SalesContactInput {
  fullName: string;
  company: string;
  emailAddress: string;
  phoneNumber: string;
  jobTitle: string;
  asNumber?: string | null;
}

export interface SupportContactInput {
  fullName: string;
  company: string;
  emailAddress: string;
  phoneNumber: string;
}
export interface PortsCountQueryArgs {
  portSpeed: PortSpeed;
}
export interface TrafficQueryArgs {
  timestampRange: TimestampRangeInput;
}
export interface TrafficsQueryArgs {
  timestampRanges: TimestampRangeInput[];
}
export interface ContactSalesMutationArgs {
  contact: SalesContactInput;
  message: string;
}
export interface ContactSupportMutationArgs {
  contact: SupportContactInput;
  message: string;
}

export enum PeeringPolicy {
  none = 'none',
  open = 'open',
  selective = 'selective',
  caseByCase = 'caseByCase',
}

export enum PortSpeed {
  G1 = 'G1',
  G10 = 'G10',
  G100 = 'G100',
  G400 = 'G400',
}

export enum ErrorMessage {
  invalidAsNumber = 'invalidAsNumber',
  invalidEmailAddress = 'invalidEmailAddress',
  required = 'required',
  invalidPhoneNumber = 'invalidPhoneNumber',
}



// WEBPACK FOOTER //
// /www/client/src/GraphQL.ts